import { Collapse } from "antd";
import { HELP_LINES } from "./constants";

const HELP_TITLE = "Dette skjer videre";

export interface HelpCardProps {
  mobile?: boolean;
}

export default function HelpCard({ mobile = false }: HelpCardProps) {
  const content = (
    <div className="sendin-help-card">
      <h2>{HELP_TITLE}</h2>
      {HELP_LINES.map((line) => (
        <p key={line}>{line}</p>
      ))}
    </div>
  );

  if (!mobile) return content;

  return (
    <Collapse
      className="sendin-help-collapse"
      items={[{ key: "help", label: HELP_TITLE, children: content }]}
    />
  );
}
